export default __webpack_public_path__ + "static/media/tele-plan-hero-1.d43016ea.png";